import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfigureBlockingModalComponent } from '../../../../../../app/home/paraEmpresas/block/configure/content.component';
import { BlockGroupService } from '../../../../../../app/services/block.group.service';
import { AlertService } from '../../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../../app/models/dataPackLine.model';
import { ConfigBlockVoiceComponent } from '../../../../../../app/home/paraEmpresas/block/voice/config/content.component';
import { VoiceBlockComponent } from '../../../../../../app/home/paraEmpresas/block/voice/content.component'
import { BindComponentService } from '../../../../../../app/utils/bind.component.service';
import { DataPackLineAcount } from '../../../../../models/dataPackLineAcount.model';
import { ModalBloqueioVozComponent } from '../blockModal/content.component';
import { LoadingComponent } from '../../../modalLoading/content.component';
import { DataPackService } from '../../../../../models/DataPackService.model';

import * as _ from 'lodash';
import { NgbAccordion } from "@ng-bootstrap/ng-bootstrap/accordion/accordion";

/**
 * @version $Id: content.component.ts 54447 2017-07-26 23:34:29Z eduardo.s.neto $
 */
@Component({
  selector: 'voiceTableBlockComponent',
  templateUrl: './content.template.html'
})
export class VoiceTableBlockComponent implements OnInit, AfterViewInit {

  private static readonly GROUPS_FETCH_SIZE: number = 100;
  private static readonly LINES_FETCH_SIZE: number = 20; 
  private static readonly FILTER_ALL_LINES = 'all_lines';
  private static readonly FILTER_BLOCKED_LINES = 'blocked_lines';
  private static readonly FILTER_UNBLOCKED_LINES = 'unblocked_lines';

  private static readonly FILTER_ALL_LINES_FILTER = 'ALL';
  private static readonly FILTER_BLOCKED_LINES_FILTER = 'VOICEBLK';
  private static readonly FILTER_UNBLOCKED_LINES_FILTER = 'VOICEUNBLK';

  public serviceType: string = VoiceTableBlockComponent.FILTER_ALL_LINES;

  public filter: string = VoiceTableBlockComponent.FILTER_ALL_LINES;
  public groupsFetchSize: number = VoiceTableBlockComponent.GROUPS_FETCH_SIZE;
  public linesFetchSize: number = VoiceTableBlockComponent.LINES_FETCH_SIZE;

  public groups: Array<DataPackGroup> = new Array<DataPackGroup>();
  public selectedLineAcount: Array<DataPackLine> = new Array<DataPackLine>();
  public displayShowMoreLinesButton: Map<string, boolean> = new Map<string, boolean>();
  public selectedGroup: DataPackGroup;
  public filteredGroups: Array<DataPackGroup> = new Array<DataPackGroup>();
  public filterValue: string = '';
  public displayShowMoreGroupsButton: boolean = false;
  public groupSortingCriteria: string;
  public groupSortingAsc: boolean = true;
  public lineSortingCriteria: string;
  public lineSortingAsc: boolean = true;
  public hideLinesGroup: boolean = false;
  public hideButton: boolean = true;
  public page: number;
  public pageGroup: number;
  public filtered: boolean = false;
  public totalGroups: number;
  public checkAll: boolean;

  @ViewChild('pageAccordion')
  pageAccordion: NgbAccordion;

  constructor(private modal: NgbModal, private blockGroupService: BlockGroupService, private alertService: AlertService, private bindComponent: BindComponentService, private modalService: NgbModal) {

  }

  ngOnInit() {
    this.loadViewBlockVoice();
    this.bindComponent.set(BindComponentService.IS_VOICE_CONSUMPTION, true);
  }

  ngAfterViewInit() {
    this.bindComponent.subscribe(BindComponentService.LOAD_VIEW_BLOCK_VOICE,
      condicao => {
            if(condicao){
              this.selectedGroup = new DataPackGroup();
              this.loadViewBlockVoice();
            }
      }
    );
    this.bindComponent.subscribe(BindComponentService.FILTER_BLOCK,
      group => {
        this.groups = new Array<DataPackGroup>();
        this.groups = group;
        this.filtered = true;

      }
    );
    
  } 

  public isSelectLinesAll(){
    return this.checkAll;
  }   


  

  private loadViewBlockVoice() {
    this.filtered = false;
    this.hideLinesGroup = false;
    this.hideButton = true;
    this.openModalLoading();
    this.checkAll = false;
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.blockGroupService.loadViewBlockVoice(1, VoiceTableBlockComponent.GROUPS_FETCH_SIZE).subscribe(
      data => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.setGroups(data['groups'], false);
        this.totalGroups = data['totalRecords'];
        this.bindComponent.set(BindComponentService.TOTAL_GROUPS, this.totalGroups);
        if(this.totalGroups > this.groupsFetchSize) {
          this.displayShowMoreGroupsButton = true;
        }

        this.pageGroup = 1;
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private setGroups(groups: Array<DataPackGroup>, append: boolean) {
    if (!append) {
      this.groups = new Array<DataPackGroup>();
      this.groups = groups;
      this.filteredGroups = groups;
    } else {
      Array.prototype.push.apply(this.groups, groups);
    }
    this.clearSelections();
  
  }

  public verificarBloqueio(condicao: boolean) {
    return (condicao) ? "Ativo" : "Inativo";
  }

  public verificarBloqueioGestor(condicao: boolean) {
    return (condicao) ? "Sim" : "Não";
  }

  public configBloqueio() {
    if (this.selectedLineAcount.length === 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }
    if (this.selectedLineAcount.length === 1) {
      this.openModalLoading();
      let isConfigsBloqueio: boolean = true;
      let line: DataPackLine = new DataPackLine();
      this.blockGroupService.getLineData(this.selectedLineAcount).subscribe(
        data => {
          let value: any =  data;
          line = value;
          this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_VOICE, isConfigsBloqueio);
          this.bindComponent.set(BindComponentService.BLOCK_VOICE_DATA_PACK_LINE, line);
          this.bindComponent.set(BindComponentService.LIST_ACOUNT_BLOC_VOICE, this.selectedLineAcount);
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        },
        err => {
          this.alertService.error(err.result, err);
        }
      );
    }
    if (this.selectedLineAcount.length > 1) {
      this.openModalBlockVoice(this.selectedLineAcount);
    }
  }

  public configBloqueioGrupo() {
      this.openModalLoading();
      let isConfigsGroupBloqueio: boolean = true;
      let isConfigsBloqueio: boolean = true;
      this.blockGroupService.getGroupData(this.selectedGroup.id).subscribe(
        data => {
          this.selectedGroup.blockedLDI = data['blockedLDI'];
          this.selectedGroup.blockedOther = data['blockedOther'];
          this.selectedGroup.facilityDataPackServices = data['facilityDataPackServices'];
          this.selectedGroup.groupControlDataPackServices = data['groupControlDataPackServices'];
          this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_VOICE, isConfigsBloqueio);
          this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_GROUP_VOICE, isConfigsGroupBloqueio);
          this.bindComponent.set(BindComponentService.BLOCK_VOICE_DATA_PACK_GROUP, this.selectedGroup);
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        },
        err => {
          this.alertService.error(err.result, err);
        }
      );
    if (this.selectedLineAcount.length > 1) {
      this.openModalBlockVoice(this.selectedLineAcount);
    }
  }
/*
  public filterLines(filter?: string) {
    this.clearSelections();
    this.filter = filter || this.filter;
    this.filteredGroups = this.groups.filter(group => {
      let groupFiltered = false;
      group.lines.forEach(line => {
        let lineFiltered = this.filter === VoiceTableBlockComponent.FILTER_ALL_LINES || (this.filter === VoiceTableBlockComponent.FILTER_BLOCKED_LINES && line.blockedLDI) ||(this.filter === VoiceTableBlockComponent.FILTER_BLOCKED_LINES && line.blockedOther)||(this.filter === VoiceTableBlockComponent.FILTER_BLOCKED_LINES && line.blockedSMS) || (this.filter === VoiceTableBlockComponent.FILTER_UNBLOCKED_LINES && !line.blockedLDI && !line.blockedOther && !line.blockedSMS);
        if (lineFiltered) {
          lineFiltered = !this.filterValue || this.filterValue === '' || this.searchText(line.userName, this.filterValue) || this.searchText(line.lineNumber, this.filterValue);
        }
        if (!groupFiltered && lineFiltered) {
          groupFiltered = true;
        }
        line.filtered = lineFiltered;
      });
      return groupFiltered;
    });
  }**/
  public filterLines(filter?: string) {

      this.clearSelections();
      this.filter = filter || this.filter;
      this.filteredGroups = this.groups.filter(group => {

      });
      return true;
  }

  public changePanel(filter?: string) {

      this.hideButton = true;


      //this.filtered = !this.filtered;
      this.clearSelections();
      this.filter = filter || this.filter;
      this.pageAccordion.activeIds = [];
      this.filteredGroups = this.groups.filter(group => {
          if (filter !== null && filter !== undefined) {
              this.filtered = false;
              this.toggleGroup(group, 1);
          }
      });
      this.selectedGroup = null;
      return true;
  }


    public configBloqueioSMS() {
    let dataPackLine: DataPackLine = new DataPackLine();
    if (this.selectedLineAcount.length === 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }

  
    if (this.selectedLineAcount.length === 1){
      this.selectedLineAcount.forEach(line => dataPackLine = line);
    }

    let modal = this.modalService.open(ConfigureBlockingModalComponent);
    modal.componentInstance.configSMS = true;
    modal.componentInstance.configGestor = false;
    modal.componentInstance.lineAcountList = this.selectedLineAcount;
    modal.componentInstance.dataPackLine = dataPackLine;
 
  }
  
  public configBloqueioGestor() {
    let dataPackLine: DataPackLine = new DataPackLine();
    if (this.selectedLineAcount.length === 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }

  
    if (this.selectedLineAcount.length === 1){
      this.selectedLineAcount.forEach(line => dataPackLine = line);
    }

    let modal = this.modalService.open(ConfigureBlockingModalComponent);
    modal.componentInstance.configSMS = false;
    modal.componentInstance.configGestor = true;
    modal.componentInstance.lineAcountList = this.selectedLineAcount;
    modal.componentInstance.dataPackLine = dataPackLine;
 
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modal-content-loading',
      size: 'lg',
    });
  }

  private openModalBlockVoice(listAcount: any) {
    this.openModalLoading();
    this.blockGroupService.getLineData(listAcount).subscribe(
      data => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        let modalRef = this.modalService.open(ModalBloqueioVozComponent);
        modalRef.componentInstance.lineNew = data;
        modalRef.componentInstance.listAcount = listAcount;
      
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );


   
  }

  private setLines(group: DataPackGroup, lines: Array<DataPackLine>, append: boolean) {
    if (!append) {
      group.lines = lines;
    } else {
      Array.prototype.push.apply(group.lines, lines);
    }
    this.filterLines();
  }



  private searchText(text: string, value: string) {
    return text ? text.toLowerCase().search(value.toLowerCase()) != -1 : false;
  }

  private toggleGroup(group: DataPackGroup,index:number) {
    if (!this.selectedGroup || this.selectedGroup.id !== group.id) {
      this.selectedGroup = group;
      this.page = 1;
    } else {
   
      this.selectedGroup = null;
    }
    this.lineSortingCriteria = null;
    this.lineSortingAsc = true;
    this.selectedLineAcount = new Array<DataPackLine>();

    this.hideButton = true;
    this.hideLinesGroup = false;
    this.displayShowMoreLinesButton[group.id] = false;
    
  }

  private sortGroups(field: string) {
    this.groupSortingAsc = this.groupSortingCriteria == field ? !this.groupSortingAsc : true;
    this.groupSortingCriteria = field;
    this.groups = _.orderBy(this.groups, [this.groupSortingCriteria], [this.groupSortingAsc ? 'asc' : 'desc']);
  }

  private sortLines(field: string) {
    this.lineSortingAsc = this.lineSortingCriteria == field ? !this.lineSortingAsc : true;
    this.lineSortingCriteria = field;
    this.selectedGroup.lines = _.orderBy(this.selectedGroup.lines, [this.lineSortingCriteria], [this.lineSortingAsc ? 'asc' : 'desc']);
  }

  private clearSelections() {
    this.selectedLineAcount = new Array<DataPackLine>();
    this.lineSortingCriteria = null;
    this.lineSortingAsc = true;
    this.groupSortingCriteria = null;
    this.groupSortingAsc = true;
  }


  private selectLine(line: DataPackLine) {
    //if (!this.selectedLineAcount.includes(line)) 
    if (!_.some(this.selectedLineAcount, line)) {
      this.selectedLineAcount.push(line);
    } else {
      let index = this.selectedLineAcount.indexOf(line);
      this.selectedLineAcount.splice(index, 1);
    }
  }

  private selectAllLines($event) {
    let checked = $event.srcElement.checked;
    if (checked) {
      this.selectedGroup.lines.forEach(line => this.selectedLineAcount.push(line));
      this.checkAll = true;
    } else {
      this.checkAll = false;
      this.selectedLineAcount = new Array<DataPackLine>()
    }
  }

  private showMoreGroups(): void {
    this.openModalLoading();
    this.pageGroup = this.pageGroup +1;
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.blockGroupService.loadViewBlockVoice(this.pageGroup, this.groupsFetchSize).subscribe(
      data => {
        this.setGroups(data['groups'], true);
        if ((this.groupsFetchSize * this.pageGroup) >= this.totalGroups) {
          this.displayShowMoreGroupsButton = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private showMoreLines(group: DataPackGroup, index: number): void {

    this.openModalLoading();
    this.page = this.page + 1;
    this.serviceType = this.filter;
    this.blockGroupService.loadingLinesNow(group, this.serviceType, this.page, this.linesFetchSize).subscribe(
      data => {
        if(data['lines'].length === group.lines.length){
          this.alertService.warn("Não existe mais linhas a serem carregadas para esse grupo.");
        }
        let value: any = data;
        this.preencherGroups(index, value);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.displayDivLines();
        this.filterLines();
        if (value.length < this.linesFetchSize) {
          this.displayShowMoreLinesButton.set(String(group.id),false) ;
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        }
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private maskMsisdn(msisdn: string): string {
    if (_.isNil(msisdn)) {
      return '';
    }
    if (msisdn.length == 12) {
      return '('.concat(msisdn.substr(0, 3)).concat(') ').concat(msisdn.substring(3, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    } else if (msisdn.length == 11) {
      return '('.concat(msisdn.substr(0, 2)).concat(') ').concat(msisdn.substring(2, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    }
    return msisdn;
  }




  private showLines(group: DataPackGroup, index: number) {

    this.serviceType = this.filter;
    if (!this.filtered) {
      this.openModalLoading();
       this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
       group.lines= new Array<DataPackLine>();
       this.blockGroupService.loadingLinesNow(group, this.serviceType, 1, this.linesFetchSize).subscribe(
        data => {
          let value: any = data;
          this.preencherGroups(index, value);
          this.displayShowMoreLinesButton[group.id] = true;
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
          this.displayDivLines();
          this.filterLines();
        },
        err => {
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
          this.alertService.error(err.result, err);
        }
      );
    } else {
      this.displayShowMoreLinesButton[group.id] = true;
      this.displayDivLines();
      this.filterLines();
    }
  }


  public displayDivLines() {
      this.hideLinesGroup = true;
      this.hideButton = false;
  }
  private hideLines(group: DataPackGroup) {
      this.hideLinesGroup = false;
      this.hideButton = true;
      if(group.id){
        this.displayShowMoreLinesButton[group.id] = false;
      }
      
   }

  public preencherGroups(index: number, data: DataPackGroup) {
    let group: DataPackGroup = this.groups[index];
    group.id = data.id;
    group.name = data.name;
    group.quota = data.quota;
    group.unallocatedQuota = data.unallocatedQuota;
    group.allocateQuota = data.allocateQuota
    group.quotaConsume = data.quotaConsume;
    group.bonusConsume = data.bonusConsume;
    group.bonus = data.bonus;
    group.extraDataPackConsume = data.extraDataPackConsume;
    group.extraDataPack = data.extraDataPack;
    group.bisConsume = data.bisConsume;
    group.bis = data.bis;
    group.percentageConsumedBis = data.percentageConsumedBis;
    group.percentageConsumedBonus = data.percentageConsumedBonus;
    group.percentageConsumedExtraDataPack = data.percentageConsumedExtraDataPack;
    group.percentageConsumedQuota = data.percentageConsumedQuota;
    group.isData = data.isData;
    group.groupDefault = data.groupDefault;
    group.manager = data.manager;
    group.lines = data.lines;
    group.totalLines = data.totalLines;
    group.totalOfUnidentifiedLines = data.totalOfUnidentifiedLines;
    group.totalOfRowsWithoutQuota = data.totalOfRowsWithoutQuota;
    group.totalOfRowsOutOfQuota = data.totalOfRowsOutOfQuota;
    group.totalOfRowsOutOflimit = data.totalOfRowsOutOflimit;
    group.totalOfRowsOutOfOverBalancelimit = data.totalOfRowsOutOfOverBalancelimit;
    group.dataNotificationsCount = data.dataNotificationsCount;
    group.voiceNotificationsCount = data.voiceNotificationsCount;
    group.limit = data.limit;
    group.consumedLimit = data.consumedLimit;
    group.availableLimit = data.availableLimit;
    group.overBalanceLimit = data.overBalanceLimit;
    group.consumedOverBalanceLimit = data.consumedOverBalanceLimit;
    group.availableOverBalance = data.availableOverBalance;
    group.percentageConsumedOverBalanceLimit = data.percentageConsumedOverBalanceLimit;
    group.overBalanceLimitNextCycleControll = data.overBalanceLimitNextCycleControll;

    
  }


  private showLinesNow(group: DataPackGroup, serviceType: string, index: number) {
      if (!this.filtered) {
          this.openModalLoading();
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
          group.lines = new Array<DataPackLine>();
          serviceType = VoiceTableBlockComponent.FILTER_ALL_LINES;
          this.blockGroupService.loadingLinesNow(group, serviceType, 1, this.linesFetchSize).subscribe(
              data => {
                  let value: any = data;
                  this.preencherGroups(index, value);
                  this.displayShowMoreLinesButton[group.id] = true;
                  this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
                  this.displayDivLines();
                  this.filterLines();
              },
              err => {
                  this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
                  this.alertService.error(err.result, err);
              }
          );
      } else {
          this.displayShowMoreLinesButton[group.id] = true;
          this.displayDivLines();
          this.filterLines();
      }
  }

  private loadViewBlockVoiceNow(serviceType:string) {
      this.filtered = false;
      this.hideLinesGroup = false;
      this.hideButton = true;
      this.openModalLoading();
      this.checkAll = false;
      this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);

      if (serviceType === VoiceTableBlockComponent.FILTER_ALL_LINES) {
          serviceType = VoiceTableBlockComponent.FILTER_ALL_LINES_FILTER;
      }

      if (serviceType === VoiceTableBlockComponent.FILTER_BLOCKED_LINES) {
          serviceType = VoiceTableBlockComponent.FILTER_BLOCKED_LINES_FILTER;
      }

      if (serviceType === VoiceTableBlockComponent.FILTER_UNBLOCKED_LINES) {
          serviceType = VoiceTableBlockComponent.FILTER_UNBLOCKED_LINES_FILTER;
      }

      this.blockGroupService.loadViewBlockVoiceNow(serviceType, 1, VoiceTableBlockComponent.GROUPS_FETCH_SIZE).subscribe(
          data => {
              this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
              this.setGroups(data['groups'], false);
              this.totalGroups = data['totalRecords'];
              this.bindComponent.set(BindComponentService.TOTAL_GROUPS, this.totalGroups);
              if (this.totalGroups > this.groupsFetchSize) {
                  this.displayShowMoreGroupsButton = true;
              }

              this.pageGroup = 1;
          },
          err => {
              this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
              this.alertService.error(err.result, err);
          }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/voice/tableVoice/content.component.ts